export const SET = 'pipelines/set'
export const CLEAR = 'pipelines/clear'
export const SAVE = 'pipelines/save'
export const DESTROY = 'pipelines/destroy'



// WEBPACK FOOTER //
// ./src/modules/parameters/pipelines/store/mutations_types.js